import React from 'react';
import EmptyPage from '../EmptyPage';

const ProjectPage: React.FC = () => {
  return (
    <EmptyPage
      title="프로젝트"
      icon="Package"
      description="진행 중인 프로젝트 목록을 관리합니다."
    />
  );
};

export default ProjectPage;
